// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1iOFu","text":"SelectPayment_text__1Q9Cd","title":"SelectPayment_title__1KtES","btn":"SelectPayment_btn__2yiB2"};